import React from 'react'
import $ from 'jquery';
import '../Styles/Domain.css'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import DomianIMg from '../assets/images/DC&G.png'
import Reload from '../assets/images/reload.png';
import ChapchaImg from '../assets/images/captcha.png'
import HappyClients from '../Components/HappyClients'
import BottomCarousel from '../Components/BottomCarousel'
import LeaderForm from '../Components/LearningForm'

function Domain() {
   $(document).ready(function(){
      $('.customer_carousel2').owlCarousel({
        loop:true,
        margin:0,
        
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        nav:false,
        dots:true,
        responsive:{
            0:{
                items:1
            },
            320:{
                items:1
            },
            480:{
                items:1
            },
            600:{
                items:1
            },
            767:{
                items:1
            },
            991:{
                items:1
            },
            1200:{
                items:2
            }
        }
    });
    });	
$(document).ready(function(){
$('.owl-carousel').owlCarousel({
items: 10, // Number of items visible at once
loop: true, // Loop the carousel
margin: 10, // Space between items
autoplay: true, // Autoplay the carousel
autoplayTimeout: 3000, // Autoplay interval in milliseconds
responsive: {
0: {
items: 1
},
768: {
items: 2
},
1024: {
items: 4
}
}
});
});
var action = 'click';
var speed = "500";
$(document).ready(function(){
$('li.q').on(action, function(){
var isOpen = $(this).hasclassName('rotate');
$('li.q').removeclassName('rotate');
$('li.a').slideUp(speed);
if (!isOpen) {
$(this).addclassName('rotate');
$(this).next().slideDown(speed);
}
}); // End on click
}); // End Ready
return (
<div className="Apsp">
   <header className="header">
      <section className='backgroung-image-Domain'>
         <Navbar/>
         <div className='header-about-content'>
            <h1>.</h1>
         </div>
      </section>
   </header>
   <main className="main">
      <section className='container about-success'>
         <div className='Testimonials-success-work'>
            {/* <!------what start--------> */}
            <div className="testimonials-bg">
               <div className="container">
                  <div className="row">
                     <h5>SERVICES</h5>
                     <h2><span>Domain compliances</span> & governance</h2>
                     <p>Business Houses are facing increasing pressure to improve their overall security posture. Volumes of regulations and stakeholder demands for transparency, accountability, enterprise risk management, and optimized performance are now the norm. A reactionary response isn’t enough. Success depends on proactively balancing risk and opportunity across the entire business environment to respond rapidly to constant change. This as a discipline brings together focus areas across corporate governance, enterprise risk management, and corporate compliance. The aim of an effective DC& G strategy is to ensure those right efficiencies are brought in and more effective information sharing and reporting mechanisms are enabled through specialized programs.
                     </p>
                  </div>
               </div>
            </div>
            {/* <!------success end--------> */}
         </div>
      </section>
      {/* program section start */}
      <section className='program-sections'>
         <div className="thisPractices">
            <div className="container">
               <img src={DomianIMg} alt="ncnbdjcn"/>
            </div>
         </div>
      </section>
      {/* program section end */}
      {/* program form Inner start */}
      <section className='Program-form'>
         <LeaderForm/>
      </section>
      {/* program form end */}
      {/* Happy Clients Start */}
      <section className='Happy-clients'>
         <HappyClients/>
      </section>
      {/* Happy Clients END */}
      {/* Brand Section Start */}
      <BottomCarousel/>
      {/* Brand Section end */}
   </main>
   {/* <!------footer start--------> */}
   <Footer/>
   {/* <!------footer end--------> */}
</div>
);
}
export default Domain;